export enum SftpAuthentication {
  Password = 'authentication-password',
  PrivateKey = 'authentication-private-key'
}
